import './home.css'
import MainHeader from '../../components/MainHeader'
import Classes from '../../components/Classes'
import Values from '../../components/Values'
import FAQs from '../../components/FAQs'

const Home = () => {
  return (
    <>
    <MainHeader/>
    <Classes/>
    <div className="calendar-embed">
      <iframe
        src="https://florium.studio/iy-sp/embed"
        title="Class Booking"
        allowpaymentrequest="true"
      />
    </div>
    <Values/>
    <FAQs/>
    </>
  )
}

export default Home
